import ApprovalFlowSubViewApp from '../Functionality/ApprovalFlowSubViewApp';
import DocumentationHeader from './DocumentationHeader';
import CustomExpandableTable from '../../../components/table/CustomExpandableTable';
import NotInformation from '../../../components/NotInformation';
import CustomButtonLink from '../../../components/buttons/CustomButtonLink';
import DeleteModal from '../../Modals/DeleteModal';
import routes from '../../../Routes/routes';
import {USER_TYPE_MODEL} from "../../../enums/userTypeEnum";
/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: full stack
 */

const ApprovalFlowSubView = ({
                                 subView,
                                 handleSubViewChange,
                                 DEV,
                                 option,
                                 permission,
                                 searchElement,
                                 setSearchElement,
                                 deleteApprovalFlowShow,
                                 setIsAllChecked,
                                 setDeleteApprovalFlowShow,
                                 selectedList,
                                 setSelectedList,
                                 search,
                                 setSearch,
                                 setSimpleSearch,
                                 viewType,
                                 userTypeId
}) => {

    const {
        t,
        searchId,
        handleCheckboxChange,
        handleDeleteAll,
        rowsPerPage,
        columns,
        searchResults,
        renderOptionsMenu,
        handleRowExpand,
        RenderDetails,
        handleDelete,
        setSearchResults,
        pagination,
        page
    } = ApprovalFlowSubViewApp({
        searchElement,
        setIsAllChecked,
        selectedList,
        setSelectedList,
        option,
        setDeleteApprovalFlowShow,
        viewType,
        userTypeId
    });

    return (
        <>
            <DocumentationHeader
                page={page}
                searchId={searchId}
                option={option}
                rowsPerPage={rowsPerPage}
                viewType={viewType}
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                DEV={DEV}
                permission={permission}
                setSearchResults={setSearchResults}
                searchResults={searchResults}
                search={search}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                userTypeId={userTypeId}
            />
            {searchResults?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={searchResults?.content}
                        renderExpandedRow={RenderDetails}
                        renderOptionsMenu={renderOptionsMenu}
                        checkbox={true}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation card={true}>
                    <>
                        <div className='warning-text'>
                            <p>{t('you_have_not_created_any_approval_flow_yet')}</p>
                        </div>

                        <CustomButtonLink
                            className={'d-block'}
                            splitName={false}
                            id='btn_afsv_create_new_level'
                            card={true}
                            url={userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE
                                ? routes.contractor.createApprovalLevel
                                : routes.suppliers.createApprovalLevel
                            }
                            name='create_new_flow'
                        />
                    </>
                </NotInformation>
            )}
            <DeleteModal
                show={deleteApprovalFlowShow}
                onHide={() => setDeleteApprovalFlowShow(false)}
                data={selectedList}
                onClickFn={() => {
                    handleDelete(selectedList);
                    setDeleteApprovalFlowShow(false);
                }}
                title_modal={'delete_approval_flow'}
                element_modal={'approval_flow'}
            />
        </>
    );
};

export default ApprovalFlowSubView;
